import {
  AnchorId,
  CommonStepId,
  HighlightRole,
  StepActionKind,
} from '../../core/Enums';
import { PaymentsStepId, PaymentsSubsceneId } from '../../core/PaymentsEnums';
import { PanelState, type Step } from '../../core/Types';
import ManagerClearedScene from './scenes/ManagerClearedScene';
import ManagerOutstandingScene from './scenes/ManagerOutstandingScene';
import ManagerTransactionsScene from './scenes/ManagerTransactionsScene';
import TenantPayScene from './scenes/TenantPayScene';

export const paymentsSteps: Step[] = [
  {
    id: PaymentsStepId.MANAGER_OUTSTANDING,
    title: 'Outstanding rent',
    Scene: ManagerOutstandingScene,
    next: PaymentsStepId.TENANT_PAY,
    defaultSubsceneId: PaymentsSubsceneId.INVOICE,
    subscenes: [
      {
        id: PaymentsSubsceneId.INVOICE,
        spotlight: {
          anchor: AnchorId.MANAGER_OUTSTANDING_OUTSTANDING_INVOICE,
          placement: 'bottom',
        },
        coach: {
          body: 'Tap the outstanding rent item to see the full details.',
        },
      },
      {
        id: PaymentsSubsceneId.PREVIEW,
        spotlight: {
          anchor: AnchorId.OPEN_TENANT_VIEW_BUTTON,
          placement: 'bottom',
          highlights: [
            {
              anchor: AnchorId.MANAGER_OUTSTANDING_OUTSTANDING_INVOICE,
              role: HighlightRole.HIGHLIGHT,
            },
            {
              anchor: AnchorId.OPEN_TENANT_VIEW_BUTTON,
              role: HighlightRole.ACTIONABLE,
            },
          ],
        },
        coach: { body: 'Preview how this rent appears to your tenant.' },
      },
    ],
  },
  {
    id: PaymentsStepId.TENANT_PAY,
    title: 'Tenant payment',
    Scene: TenantPayScene,
    next: PaymentsStepId.MANAGER_CLEARED,
    defaultSubsceneId: PaymentsSubsceneId.LIST,
    subscenes: [
      {
        id: PaymentsSubsceneId.LIST,
        spotlight: {
          anchor: AnchorId.TENANT_PAYMENTS_MAKE_PAYMENT,
          placement: 'bottom',
          highlights: [
            {
              anchor: AnchorId.TENANT_PAYMENTS_INVOICE_ACCORDION,
              role: HighlightRole.HIGHLIGHT,
            },
            {
              anchor: AnchorId.TENANT_PAYMENTS_MAKE_PAYMENT,
              role: HighlightRole.ACTIONABLE,
            },
          ],
        },
        coach: { body: 'Tap "Make a payment" to review the rent details.' },
      },
      {
        id: PaymentsSubsceneId.REVIEW,
        spotlight: {
          anchor: AnchorId.TENANT_REVIEW_PAY_NOW,
          placement: 'bottom',
          highlights: [
            {
              anchor: AnchorId.TENANT_REVIEW_ACCORDION_LIST,
              role: HighlightRole.HIGHLIGHT,
            },
            {
              anchor: AnchorId.TENANT_REVIEW_PAY_NOW,
              role: HighlightRole.ACTIONABLE,
            },
          ],
        },
        coach: { body: 'Review the details, then submit the payment.' },
      },
      {
        id: PaymentsSubsceneId.PROCESSING,
        coach: { body: 'Processing the payment.' },
      },
      {
        id: PaymentsSubsceneId.SUCCESS,
        spotlight: {
          anchor: AnchorId.TENANT_REVIEW_SUCCESS_CONTINUE,
          placement: 'bottom',
        },
        coach: {
          body: 'Payment successful. Return to manager view to see how this payment appears.',
        },
      },
    ],
    coach: {
      body: 'Make a payment, then submit it for processing.',
      primary: {
        label: 'Make payment',
        do: { action: StepActionKind.NEXT },
      },
    },
  },
  {
    id: PaymentsStepId.MANAGER_CLEARED,
    title: 'Rent paid',
    Scene: ManagerClearedScene,
    next: PaymentsStepId.MANAGER_TRANSACTIONS,
    subscenes: [
      {
        id: PaymentsSubsceneId.CLEARED,
        spotlight: {
          anchor: AnchorId.MANAGER_CLEARED_PLACEHOLDER,
          placement: 'bottom',
          highlights: [
            {
              anchor: AnchorId.MANAGER_CLEARED_PLACEHOLDER,
              role: HighlightRole.HIGHLIGHT,
            },
            {
              anchor: AnchorId.MANAGER_CLEARED_TRANSACTIONS_TAB,
              role: HighlightRole.ACTIONABLE,
            },
          ],
        },
        coach: {
          body: 'The rent is now paid. Open Transactions to see a record of the payment.',
        },
      },
    ],
  },
  {
    id: PaymentsStepId.MANAGER_TRANSACTIONS,
    title: 'Transactions log',
    Scene: ManagerTransactionsScene,
    next: CommonStepId.TOUR_COMPLETE,
    defaultSubsceneId: PaymentsSubsceneId.PAYMENT,
    subscenes: [
      {
        id: PaymentsSubsceneId.PAYMENT,
        spotlight: {
          anchor: AnchorId.MANAGER_TRANSACTIONS_RENT_PAYMENT,
          placement: 'bottom',
        },
        coach: {
          body: 'Open the rent payment to see the full details.',
        },
      },
    ],
  },
  {
    id: CommonStepId.TOUR_COMPLETE,
    title: 'Tour complete',
    Scene: ManagerTransactionsScene,
    onEnter: {
      panel: PanelState.Expanded,
    },
    spotlight: {
      anchor: AnchorId.TOUR_CHECKLIST_PANEL,
      highlights: [],
    },
  },
];
